import axios, { AxiosResponse } from 'axios';
import { FetchRightBarData } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { getEmptyRightBarData } from './rightBarFallback';

export const getRightBarApi = async ({
  sortType,
  currentPage,
}: FetchRightBarData) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const user_id = localStorage.getItem('user_id');
  const apiEndpoint = GET_BASE_URL + '/api/v1/rightBar?user_id=' + user_id;

  try {
    const { data } = await axios
      .get<Lounge[]>(`${apiEndpoint}`)
      .then(responseBody);

    return data;
  } catch (err) {
    return getEmptyRightBarData();
  }
};
